import { Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from '@mui/icons-material/Close';
import React from "react";
import "../../style/style.scss";
import "./Dialog.scss"
interface DialogProp {
    onClose(): void;
    open: boolean;
}

const useStyles = makeStyles(() => ({
    paper: {
        overflowY: 'unset',
    },
}));
const DialogComponent: React.FC<DialogProp> = ({ onClose, open, children }): JSX.Element => {

    const classes = useStyles();
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} open={open} classes={{ paper: classes.paper }}>
            {/* <DialogTitle>{title}</DialogTitle>] */}
            <DialogActions>
                <IconButton className='closButton' onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogActions>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default DialogComponent;
